<template>
  <div>
    <div class="sign-cta bg-footer text-footer-color">
      <div class="container d-flex justify-content-center align-items-center h-100 px-3">
        <span class="cta-text mr-3">Ready to sign this document?</span>
        <button type="button"
                class="btn btn-tertiary"
                :disabled="formDisabled"
                data-toggle="modal"
                data-target="#signContractModal">
          <i class="fas fa-signature mr-2"></i>Sign
        </button>
      </div>
    </div>

    <div class="modal bottom-sheet fade"
         id="signContractModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="signContractModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content bg-footer text-footer-color">
          <div class="modal-header border-0">
            <button type="button" class="close text-footer-color ml-auto" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="signing-content mx-auto">
              <error-banner v-if="error" :message="error"></error-banner>
              <fieldset :disabled="formDisabled">
                <div class="form-group">
                  <label>Full name</label>
                  <input v-model="signedName" class="form-control" type="text" required placeholder="Please enter name" />
                  <div v-if="validator.nameError" class="error mt-1">{{ validator.nameError }}</div>
                </div>
                <div class="form-group">
                  <label>Signature</label>
                  <signature-pad v-model="signedText">
                    <template #validation>
                      <div v-if="validator.signatureError" class="error mb-2">{{ validator.signatureError }}</div>
                    </template>
                    <button @click="tryAddSignature" class="btn btn-tertiary">
                      Complete
                      <inline-loader v-if="loading"></inline-loader>
                    </button>
                  </signature-pad>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SignatureHelper } from '@/helpers/SignatureHelper'
import { WebApi } from '@/services/WebApi'
import SignaturePad from './SignaturePad.vue'
import InlineLoader from '../Loading/InlineLoader.vue'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'

export default {
  name: 'SigningForm',
  data () {
    return {
      error: '',
      signature: null,
      loading: false,
      signedName: '',
      signedText: '',
      validator: SignatureHelper.getSignatureValidator()
    }
  },
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: {
    contractId () {
      return this.contract.id
    },
    formDisabled () {
      return this.loading || !!this.signature
    },
    signatureAddModel () {
      return {
        signedName: this.signedName,
        signedText: this.signedText
      }
    }
  },
  methods: {
    tryAddSignature () {
      const self = this
      self.validator.validate(self.signatureAddModel)
      if (!self.validator.isValid) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.post('ClientContract/' + self.contractId + '/Signature', self.signatureAddModel)
        .then(response => {
          self.signature = response.data
          const $modal = $('#signContractModal')
          $modal.one('hidden.bs.modal', () => self.$emit('signed'))
          $modal.modal('hide')
        })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    tryFetchSignature () {
      const self = this
      self.error = ''
      self.loading = true
      WebApi.get('ClientContract/' + self.contractId + '/Signature')
        .then(response => { self.signature = response.data })
        .catch(error => {
          if (!ErrorHelper.isNotFound(error)) {
            self.error = ErrorHelper.getError(error)
          }
        })
        .finally(() => { self.loading = false })
    }
  },
  components: {
    'signature-pad': SignaturePad,
    'inline-loader': InlineLoader,
    'error-banner': ErrorBanner
  },
  created () {
    this.tryFetchSignature()
  },
  beforeDestroy () {
    $('#signContractModal').modal('hide')
  }
}
</script>

<style scoped>
.sign-cta {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3.5rem;
  z-index: 1020;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

.cta-text {
  font-size: 1rem;
  font-weight: 500;
}

.bottom-sheet :deep(.modal-dialog) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  margin: 0;
}

.bottom-sheet :deep(.modal-content) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border-bottom: 0;
  max-height: 90vh;
}

.bottom-sheet :deep(.modal-body) {
  overflow-y: auto;
}

.bottom-sheet.fade :deep(.modal-dialog) {
  transform: translate(0, 100%);
  transition: transform 0.3s ease-out;
}

.bottom-sheet.show :deep(.modal-dialog) {
  transform: translate(0, 0);
}

.signing-content {
  max-width: 500px;
}

.form-control {
  background: #FFEDB2;
  border: 1px solid #121820;
}

.error {
  color: #FF576C;
  font-size: 1rem;
}
</style>
